<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <el-radio-group v-model="radioDate" size="small">
                    <el-radio-button v-for="(item,index) in date" :key="index" :label="item"></el-radio-button>
                </el-radio-group>
            </div>
            <div>
                <el-table :data="tableData"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="salesRank" label="销售排名"></el-table-column>
                    <el-table-column prop="clinicName" label="医院/诊所名称"></el-table-column>
                    <el-table-column prop="salesVolume" label="销售笔数"></el-table-column>
                    <el-table-column prop="salesValue" label="销售金额"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="seeDetails(scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="销售详情" :visible.sync="dialogCheckVisible" width="40%">
            <el-table :data="dialogData"
                      :header-cell-style="{'padding-left': '3%'}"
                      :cell-style="{'padding-left': '3%'}">
                <el-table-column prop="doctor" label="医生"></el-table-column>
                <el-table-column prop="orderQuantity" label="订单数"></el-table-column>
                <el-table-column prop="money" label="金额(元)"></el-table-column>
                <el-table-column prop="rank" label="销售排名"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="dialogPageNum"
                        :page-size="dialogPageSize"
                        :total="dialogTotal"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogCheckVisible = false" style="width: 76px">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                date: ['本周','上周','本月','上月'],
                radioDate: '本周',
                tableData: [
                    {
                        salesRank: '1',
                        clinicName: '补君堂',
                        salesVolume: '12345',
                        salesValue: '123456'
                    }
                ],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                dialogCheckVisible: false,
                dialogData: [
                    {
                        doctor: '大师傅',
                        orderQuantity: '111',
                        money: '1234',
                        rank: '1',
                    }
                ],
                // 分页信息
                dialogPageNum: 1,
                dialogPageSize: 10,
                dialogTotal: 1,
                dialogPages: 1,
            }
        },
        methods: {
            // 获取表格数据
            getData() {
                console.log(111)
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.queryDiagnose();
            },
            seeDetails(data) {
                this.dialogCheckVisible = true
            }
        },
        computed: {

        }
    }

</script>

<style>

</style>

<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 12px;
        height: 52px;
    }
</style>
